/*=========================================================================================
  File Name: moduleMap.js
  Description: Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./modulePreferencesState.js";
import mutations from "./modulePreferencesMutations.js";
import actions from "./modulePreferencesActions.js";
import getters from "./modulePreferencesGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
